(() => {
  const root = document.documentElement;
  const body = document.body;

  const syncScrollState = () => {
    root.dataset.scrolled = window.scrollY > 12 ? 'true' : 'false';
  };

  const closeMobileNav = () => {
    document.querySelectorAll('.sevicho-header').forEach((header) => {
      const button = header.querySelector('[data-sevicho-nav-toggle]');
      const nav = header.querySelector('.sevicho-header__nav');
      if (!button || !nav) return;
      button.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
    });
    body.classList.remove('sevicho-nav-open');
  };

  syncScrollState();
  window.addEventListener('scroll', syncScrollState, { passive: true });
  window.addEventListener('resize', () => {
    if (window.innerWidth > 989) closeMobileNav();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-sevicho-nav-close]')) {
      closeMobileNav();
      return;
    }

    if (event.target.closest('.sevicho-header__nav a')) {
      closeMobileNav();
      return;
    }

    const navOpen = body.classList.contains('sevicho-nav-open');
    const clickedInsideHeader = event.target.closest('.sevicho-header__inner');

    if (navOpen && !clickedInsideHeader) {
      closeMobileNav();
    }
  });

  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        sectionObserver.unobserve(entry.target);
      });
    },
    {
      threshold: 0.14,
      rootMargin: '0px 0px -8% 0px'
    }
  );

  document.querySelectorAll('main .shopify-section').forEach((section) => {
    section.classList.add('sevicho-reveal');
    sectionObserver.observe(section);
  });

  document.querySelectorAll('.sevicho-faq').forEach((faq) => {
    faq.querySelectorAll('details').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        faq.querySelectorAll('details[open]').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  });
})();
